import React, { useState, useEffect, ChangeEvent } from 'react';
import { Input, Button, Row, Col, Form, FormGroup } from 'reactstrap';
import Viewer from 'react-viewer';
import config from 'config';
import { encodeFileName } from '../../../helpers/filesPreview';
import DatePickerFullDate from 'components/DatePickerFullDate';

function CancelationForm(props: any) {
  const {
    data,
    setData,
    setResolucionFile,
    gallery,
    galleryContainer,
    isLoading,
    onAccept,
    onReject,
    onFinalizarRematriculacion,
  } = props;

  const archivoResolucion = data.attachs?.find(
    (a: { attachment_type: string }) => a.attachment_type === 'archivo_resolucion',
  );

  const [hasMotivoRechazo, setHasMotivoRechazo] = useState(false);

  useEffect(() => {
    setHasMotivoRechazo(!!data.motivo_rechazo);
  }, [data.id]);

  const accept = () => {
    if (!onAccept) {
      return;
    }

    onAccept();
  };

  const reject = () => {
    if (!onReject) {
      return;
    }

    onReject();
  };

  const finalizarRematriculacion = () => {
    if (!onFinalizarRematriculacion) {
      return;
    }

    onFinalizarRematriculacion();
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { target } = event;

    // Guardamos el nuevo valor
    setData({
      ...data,
      [target.name]: target.value,
    });
  };

  return (
    <Form>
      <Row>
        <Col sm={6}>
          <h6 className="heading text-muted mb-4">
            Matriculado Solicitante
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Matricula</label>
                <p>{ data.matricula_ck.MTR001_N_MATRICULA || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Delegación</label>
                <p>{ data.matricula_ck.MTR001_ID_DELEGACION || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Nombre</label>
                <p>{ data.matricula_ck.MTR001_D_NOMBRE || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Apellido</label>
                <p>{ data.matricula_ck.MTR001_D_APELLIDO || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Pago
          </h6>
          { data.forma_pago === 'tarjeta' &&
            <>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Modalidad de pago</label>
                    <p>Tarjeta</p>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Tipo de Tarjeta</label>
                    <p>{ data.tipo_tarjeta || '-' }</p>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Número de Tarjeta</label>
                    <p>{ data.numero_tarjeta_cbu || '-' }</p>
                  </FormGroup>
                </Col>
              </Row>
            </>
          }
          { data.forma_pago === 'bancaria' &&
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <label className='form-control-label'>Modalidad de pago</label>
                  <p>Cuenta Bancaria</p>
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <label className='form-control-label'>CBU</label>
                  <p>{ data.numero_tarjeta_cbu || '-' }</p>
                </FormGroup>
              </Col>
            </Row>
          }
          { data.forma_pago === 'efectivo' &&
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <label className='form-control-label'>Modalidad de pago</label>
                  <p>Efectivo</p>
                </FormGroup>
              </Col>
            </Row>
          }
          { data.forma_pago !== 'tarjeta' && data.forma_pago !== 'bancaria' && data.forma_pago !== 'efectivo' &&
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <label className='form-control-label'>Modalidad de pago</label>
                  <p>-</p>
                </FormGroup>
              </Col>
            </Row>
          }
          { data.state_id != 2
            ?
              <>
                <hr className="my-4" />
                <h6 className="heading text-muted mb-4">
                  Rechazo
                </h6>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <label className='form-control-label'>Motivo de rechazo</label>
                      {
                        hasMotivoRechazo
                          ?
                            <p>{ data.motivo_rechazo }</p>
                          :
                            <Input
                              id="motivo_rechazo"
                              name="motivo_rechazo"
                              type="textarea"
                              value={data.motivo_rechazo ?? ''}
                              onChange={handleInputChange}
                              disabled={isLoading}
                              required
                            />
                      }
                    </FormGroup>
                  </Col>
                </Row>
              </>
            : null
          }
        </Col>
        <Col sm={6}>
          <div className="">
            <label className="form-control-label">Adjuntos</label>
            <div
              id="gallery-container"
              style={{ height: '80vh' }}
              ref={galleryContainer}
            >
              {
                Array.isArray(gallery) &&
                gallery.length &&
                galleryContainer.current
                  ?
                    <Viewer
                      container={galleryContainer.current}
                      noClose={true}
                      visible={true}
                      disableMouseZoom={true}
                      downloadable={true}
                      disableKeyboardSupport={true}
                      zoomSpeed={0.5}
                      downloadInNewWindow={true}
                      noImgDetails={true}
                      scalable={false}
                      showTotal={false}
                      defaultScale={1.25}
                      defaultImg={{
                        src: require('../../../assets/img/404.png'),
                      }}
                      images={gallery}
                    />
                  : null
              }
            </div>
          </div>
        </Col>
      </Row>
      {
        onAccept || onReject
          ? <Row>
              <hr className="my-4" />
              <Col className="text-center">
                <Button color="danger" onClick={ reject } disabled={ isLoading }>Rechazar</Button>
                <Button color="success" onClick={ accept } disabled={ isLoading }>Aceptar</Button>
              </Col>
            </Row>
          : null
      }
      {
        (
          !!data.payment_id &&
          !!data.payment &&
          !!data.payment.payment_id &&
          data.payment.status === 'approved'
        )
          ?
            <>
              <hr className="my-4" />
              <h6 className="heading text-muted mb-4">
                Pago Rematriculación
              </h6>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>ID de Pago</label>
                    <p>{ data.payment.payment_id }</p>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <label className='form-control-label'>Preference ID</label>
                    <p>{ data.payment.preference_id }</p>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <FormGroup>
                    <label className='form-control-label'>Monto</label>
                    <p>$ { data.payment_amount }</p>
                  </FormGroup>
                </Col>
              </Row>
              {
                data.state_id == 2 && data.matricula_ck.MTR001_ESTADO == 0
                  ?
                    <>
                      <Row>
                        <Col sm={4}>
                          <FormGroup>
                            <label className='form-control-label'>Número de Resolución</label>
                            <Input
                              id="numero_resolucion"
                              name="numero_resolucion"
                              type="number"
                              value={data.numero_resolucion ?? ''}
                              onChange={handleInputChange}
                              disabled={isLoading}
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup>
                            <label className='form-control-label'>Fecha de Resolución</label>
                            <DatePickerFullDate
                              className={`form-control`}
                              id="fecha_resolucion"
                              name="fecha_resolucion"
                              onChange={ (val: string) => setData({ ...data, fecha_resolucion: val }) }
                              disabled={ isLoading }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          <FormGroup>
                            <label className='form-control-label'>Archivo de Resolución (PDF)</label>
                            <Input
                              id="archivo_resolucion"
                              name="archivo_resolucion"
                              type="file"
                              accept="application/pdf"
                              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                setResolucionFile?.(event.target.files?.[0] ?? null);
                              }}
                              disabled={isLoading}
                              required
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <hr className="my-4" />
                        <Col className="text-center">
                          <Button
                            color="success"
                            onClick={ finalizarRematriculacion }
                            disabled={ isLoading }>
                            Finalizar Rematriculación
                          </Button>
                        </Col>
                      </Row>
                    </>
                  : null
              }
              {
                !!data.numero_resolucion && !!data.fecha_resolucion
                  ?
                    <>
                      <h6 className="heading text-muted mb-4">
                        Resolución
                      </h6>
                      <Row>
                        <Col sm={6}>
                          <FormGroup>
                            <label className='form-control-label'>Número de Resolución</label>
                            <p>{ data.numero_resolucion }</p>
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup>
                            <label className='form-control-label'>Fecha de Resolución</label>
                            <p>{ data.fecha_resolucion }</p>
                          </FormGroup>
                        </Col>
                      </Row>
                      { archivoResolucion
                        ?
                          <Row>
                            <Col sm={12}>
                              <FormGroup>
                                <label className='form-control-label'>Archivo de Resolución</label>
                                <p>
                                  <a
                                    href={`${config.baseUrl}/${encodeFileName(archivoResolucion.url)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Ver PDF
                                  </a>
                                </p>
                              </FormGroup>
                            </Col>
                          </Row>
                        : null
                      }
                    </>
                  : null
              }
            </>
          : null
      }
    </Form>
  );
}

export default CancelationForm;
